<template>
  <div
    class="absolute_center"
    :class="{_boxBg_green_secondLevel:styleType == 'typeGreen',_boxBg_dark_secondLevel:styleType == 'typeDark' ,_boxBg_blue_secondLevel:styleType == 'typeBlue'}"
  >
    <div class="selfClose_btn" style="top:10px" @click="close"></div>
    <div class="_boxTitle">导出参数</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline" v-if="customerId == 59">
            <el-form-item label="日期：" v-if="customerId == 59">
              <el-date-picker
                v-model="params.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @calendar-change="handleChange"
                :disabledDate="disabledDate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label=" ">
              <a class="self_btn" @click="exportExcel()">导出</a>
              <a class="self_btn" @click="reset()">重置</a>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline" v-if="customerId == 45">
            <el-form-item label="进厂起止时间：" class="w-650">
<!--              <el-date-picker
                v-model="inTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabledDate="disabledDate"
              ></el-date-picker>-->
              <DatePicker
                @dateChange="timeChange"
                :startTimeStr="inTime[0]"
                :endTimeStr="inTime[1]"
                :current-date-list="inTime"
                dateType="timerange"
                :initWidth="'420px'"
                topPx="50px"
              />
            </el-form-item>
            <el-form-item label="出厂起止时间：" class="w-650">
<!--              <el-date-picker
                v-model="outTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabledDate="disabledDate"
              ></el-date-picker>-->
              <DatePicker
                @dateChange="dateChange"
                :startTimeStr="outTime[0]"
                :endTimeStr="outTime[1]"
                :current-date-list="outTime"
                :initWidth="'420px'"
                dateType="timerange"
                topPx="50px"
              />
            </el-form-item>
            <el-form-item label="车辆运输类型" class="w-300">
              <!-- <el-select v-model="vehicleType">
                <el-option v-for="(item, i) in transportTypeList" :key="i" :value="item.value" :label="item.label"></el-option>
              </el-select>-->
              <el-input v-model="vehicleType" />
            </el-form-item>
            <el-form-item label="货物名称" class="w-300">
              <el-input v-model="materialName" />
            </el-form-item>
            <el-form-item label="进厂门岗" class="w-300">
              <el-input v-if="customerId == 19" v-model="inGatePostName" />
              <el-input v-else v-model="inGatePostCode" />
            </el-form-item>
            <el-form-item label="出厂门岗" class="w-300">
              <el-input v-model="outGatePostCode" />
            </el-form-item>
            <el-form-item label=" ">
              <a class="self_btn" @click="exportExcel2()">导出</a>
              <a class="self_btn" @click="reset2()">重置</a>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tips" v-show="showTips">数据下载中,请稍后...</div>
    </div>
  </div>
</template>
<script>
import {dateFormat, formatDateTime} from '@/utils/tools.js'
import { DatePicker } from "@/modules/commonDatePicker/index.js";
export default {
  name: 'vehicleMateria',
  props: ['globalInstance'],
  setup(props) {
    const globalInstance = props.globalInstance
    return { globalInstance }
  },
  components:{ DatePicker },
  data() {
    return {
      params: {
        date: [new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000), new Date(new Date().getTime())]
      },
      showTips: false,
      pickDay: '',
      between: 31,
      customerId: this.$store.state.customerId,
      inTime: [
        formatDateTime(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) + ' 00:00',
        formatDateTime(new Date().getTime()) + ' 00:00',
      ],
      outTime: [
        formatDateTime(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) + ' 00:00',
        formatDateTime(new Date().getTime()) + ' 00:00',
      ],
      vehicleType: '',
      transportTypeList: [
        { value: 1, label: '大宗运输车辆' },
        { value: 2, label: '非大宗运输车辆' }
      ],
      materialName: '',
      inGatePostCode: '',
      outGatePostCode: ''
    }
  },
  computed: {
    styleType() {
      return this.globalInstance.$store.state.styleType
    }
  },
  mounted() {},

  methods: {
    timeChange (time) {
      this.inTime = time;
    },
    dateChange (time) {
      this.outTime = time;
    },
    handleChange(val) {
      if (this.between) {
        const [pointDay] = val
        this.pickDay = pointDay
      }
    },
    disabledDate(time) {
      if (!this.pickDay) {
        return false
      }
      if (this.between) {
        const con1 = new Date(this.pickDay).getTime() - this.between * 24 * 60 * 60 * 1000
        const con2 = new Date(this.pickDay).getTime() + this.between * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }
      return false
    },
    exportExcel() {
      this.showTips = true
      let that = this

      setTimeout(function () {
        that.showTips = false
      }, 5000)
      let ip = this.globalInstance.cleanTransportIp
      let str = `${ip}/ext/transport/export_inout_list?startTime=${dateFormat('YYYY-mm-dd', this.params.date[0]) + ' 00:00:00'}&endTime=${
        dateFormat('YYYY-mm-dd', this.params.date[1]) + ' 23:59:59'
      }`
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    exportExcel2() {
      this.showTips = true
      let that = this

      setTimeout(function () {
        that.showTips = false
      }, 5000)
      let ip = this.globalInstance.cleanTransportIp
      let str = `${ip}/transport/export_inout_list?inStartTime=${
        this.inTime[0] ? dateFormat('YYYY-mm-dd HH:MM:SS', this.inTime[0]) : ''
      }&inEndTime=${this.inTime[1] ? dateFormat('YYYY-mm-dd HH:MM:SS', this.inTime[1]) : ''}&outStartTime=${
        this.outTime[0] ? dateFormat('YYYY-mm-dd HH:MM:SS', this.outTime[0]) : ''
      }&outEndTime=${this.outTime[1] ? dateFormat('YYYY-mm-dd HH:MM:SS', this.outTime[1]) : ''}&materialName=${
        this.materialName
      }&vehicleType=${this.vehicleType}&inGatePostCode=${this.inGatePostCode}&outGatePostCode=${this.outGatePostCode}`
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    reset() {
      this.params = {
        date: [new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000), new Date(new Date().getTime())]
      }
    },
    reset2() {
      // this.inTime = [new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000), new Date(new Date().getTime())]
      // this.outTime = [new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000), new Date(new Date().getTime())]
      this.inTime = []
      this.outTime = []
      this.vehicleType = ''
      this.materialName = ''
      this.inGatePostCode = ''
      this.outGatePostCode = ''
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that)
    }
  },
  unmounted() {
    this.reset()
  }
}
</script>
<style lang="scss" scoped>
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
}
.tips {
  text-align: center;
  margin-top: 50px;
}
.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
}
.w-650 {
  width: 650px;
}
.w-300 {
  width: 300px;
}
::v-deep .el-input .el-input__inner {
  height: 32px;
  font-size: 20px;
  color: #fff;
  opacity: 1;
}
</style>
